module.exports = __webpack_public_path__ + "img/completed.ed23a551.svg";